<template>
  <div class="container">
    <form id="formProcesso" v-if="options.length" @submit.prevent="setProcesso()" class="ajax_off">
      <div class="form-group d-flex align-items-center">
        <label>Selecione o Processo/Ano</label>
        <model-select name="processos" :options="options" v-model="selected" placeholder="-- Selecione o processo --">
        </model-select>
        <b-button v-b-tooltip.hover.top title="Cadastrar Processo" variant="success" @click="options = []"><i
            class="fas fa-plus"></i></b-button>
      </div>
    </form>
    <div class="form-group" v-else>
      <processo-form externo :cliente="cartao.cliente" @processoCriado="processoCriado" />
    </div>

    <SingleProcessoTable :custom_params="{
      filter: [{ name: 'id', value: selected.value }]}" v-if="selected && selected.value != null"></SingleProcessoTable>
  </div>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";
import ProcessoForm from "../../processos/forms/ProcessoForm.vue";
import SingleProcessoTable from "@components/processos/SingleProcessoTable.vue";

export default {
  components: { ModelSelect, ProcessoForm, SingleProcessoTable },
  data() {
    return {
      processo_id: "",
      selected: {},
      options: [{ value: "", text: "" }],
    };
  },
  watch: {
    selected(newValue, oldValue) {
      this.processo_id = newValue.value;
    },
  },
  props: {
    cartao: Object,
  },
  created() {
    this.getProcessos();
  },
  methods: {
    processoCriado(processo) {
      this.processo_id = processo.id;
      this.setProcesso();
    },
    async setProcesso() {
      let processo_id = this.processo_id;

      await this.$api.put("tarefa/setProcesso", {
        tarefa_id: this.cartao.tarefa_id,
        processo_id,
      });

      this.$bvModal.hide("LigarProcesso");

      this.$emit("updateCartao");
    },
    async getProcessos() {
      const result = await this.$api.get(
        `processos/cliente/${this.cartao.loja_id}`
      );
      this.options = result.data;

      if (this.cartao.tabela_id) {
        let selectedIndex = this.options.findIndex(
          (item) => item.value == this.cartao.tabela_id
        );
        this.selected = this.options[selectedIndex];
      }
    },

  },
};
</script>